<template>
  <div class="m-0 dbozone-font body">
    <div class="col-12 justify-content-center d-flex flex-row header-moemoecute">
      <div class="px-3 col-3 p-0">
        <div class="heading-moemoecute">{{ $t('result.round') }}</div>
        <div class="text-subhead-moemoecute">{{ data.roundId }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-moemoecute">{{ $t('result.bet') + `${currency}` }}</div>
        <div class="text-subhead-moemoecute">{{ data.count === 0
          ? data.bet
          : data.detail.summary[data.count].bet.amount | currencyFormatter }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-moemoecute">{{ $t('result.winlose') + `${currency}` }}</div>
        <div class="text-subhead-moemoecute">{{ winlose | currencyFormatter }}</div>
      </div>
      <div class="px-3 col-3">
        <div class="heading-moemoecute">{{ $t('result.balance') + `${currency}` }}</div>
        <div class="text-subhead-moemoecute">{{ balance | currencyFormatter }}</div>
      </div>
    </div>
    <div class="content-result-moemoecute pt-3">
      <div class="text-games-moemoecute">{{ 'MOE MOE CUTE' }}</div>
      <div class="text-subgame-moemoecute">{{ $t('moemoe.name') }}</div>
      <div class="text-date mb-1">{{ data.timestamp  }}</div>
      <div class="col-12 justify-content-center d-flex flex-row p-0" style="margin-top: 100px">
        <div class="col-1 d-flex align-items-center justify-content-center" style="color: white;">
          <i v-if="isFreespin || isRespin" class="fas fa-caret-left arrow-side-moemoecute" @click="delCount()"></i>
        </div>
        <div class="wheel-wrapper multiplier-wrapper">
          <img v-if="isFreespin" class="multiplier-image" width="100%"
            :src="require(`../../assets/resultGame/moemoe/multiplier${multiplier}_freespins.png`)" alt="">
          <img v-else class="multiplier-image" width="100%"
            :src="require(`../../assets/resultGame/moemoe/multiplier${multiplier}_normal.png`)" alt="">
        </div>
        <div class="wheel-wrapper" style="z-index: 7;">
          <img class="fg-image" :src="require(`../../assets/resultGame/moemoe/slot_slotmachine.png`)" alt="">
        </div>
        <div class="table-moemoecute container d-flex flex-column justify-content-center">
          <table>
            <tbody>
              <tr v-for="(row, index) in table" :key="index">
                <td v-for="(col, i) in row" :key="i">
                  <img class="icon-symbol-moemoecute" :src="require(`../../assets/resultGame/moemoe/symbol_${col}.png`)"
                    alt="">
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-1 d-flex align-items-center justify-content-center">
          <i v-if="!isEndRound" class="fas fa-caret-right arrow-side-moemoecute" @click="addCount()"></i>
        </div>
      </div>
      <div class="text-center py-4 text-games-moemoecute">
        <h1 v-if="isFreespin">FREESPIN {{ data.count + 1 }}/{{ data.detail.summary.length }}</h1>
        <h1 v-else>SPIN {{ data.count + 1 }}/{{ data.detail.summary.length }}</h1>
      </div>
      <div v-if="winnings.length > 0" class="col-12 justify-content-center d-flex flex-row">
        <hr class="line col-3">
        <div class="text-detail align-items-center d-flex px-3">{{ $t('result.detail') }}</div>
        <hr class="line col-3">
      </div>
      <div v-if="data.detail.featureBuy" class="text-subgame-moemoecute">Feature Buy</div>
      <div v-if="winnings.length" class="col-12 justify-content-center d-flex flex-row">
        <div class="bet-box-moemoecute p-2 px-3">
          <div class="bet-warpper item" v-for="(detail, index) in winnings" :key="index">
            <div class="d-flex item justify-content-between px-1 mb-2">
              <div class="bet-wrapper-moemoecute item">
                <div class="d-flex justify-content-start bet-wrapper-moemoecute item">
                  <img class="icon-detail-moemoecute"
                    :src="require(`../../assets/resultGame/moemoe/symbol_${detail.symbol}.png`)" alt="">
                  <div class="d-flex flex-column align-items-start justify-content-center">
                    <p class="my-1 green">{{ `${detail.count} ` + $t('result.kind') }}</p>
                    <p>Line {{ `${detail.line + 1} ` }}</p>
                  </div>
                  <div class="d-flex flex-column justify-content-center px-3">
                    <p class="my-1">{{ currency }} {{ detail.amount | currencyFormatter }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../../services/utils'
export default {
  name: 'result-moemoecute',
  props: {
    data: Object,
    page: Number,
    isback: Boolean
  },
  data() {
    return {
      headerHeight: null,
      table: [
        [1, 5, 8, 12, 16,],
        [2, 6, 9, 13, 17,],
        [3, 7, 10, 14, 18,],
        [4, 8, 11, 15, 19,],
      ],
      dateTimeFormatter: function formatter(date) { return utils.dateTimeFormatter(date) },
      tokenData: utils.getTokenData(this.$route.query.t),
      date: '',
      time: '',
      // result: this.data,
      count: this.data.count,
      countSymbol: [],
      symbolsDetail: [],
      bonusGames: false,
      symbolsBonus: [],
      currency: this.data.currency ? this.data.currency : 'THB',
      ratecurrency: this.data.rateCurrency ? this.data.rateCurrency : 1,
      isFreespin: false,
      multiplier: 0,
      isEndRound: false,
      winlose: 0,
      balance: 0,
      winnings: [],
      pages: 0,
    }
  },
  async created() {
    if (this.isback) {
      this.data.count = this.data.detail.summary.length - 1;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
    else {
      this.data.count = 0;
      await this.mapSymbol(this.data.detail.summary[this.data.count]);
    }
  },
  methods: {
    onResize() {
      this.headerHeight = document.getElementsByClassName('header-moemoecute')[0].offsetHeight
    },
    mapSymbol(result) {
      if (!this.currency.includes("(")) {
        this.currency = this.tokenData.isSymb === false ? '' : `(${this.currency})`;
      }
      this.multiplier = result.multiplier
      this.isFreespin = (result.state === 'FREESPIN' || result.state === 'FREERESPIN')
      this.isRespin = result.state === 'RESPIN'

      this.table[0][0] = result.nextReel[0][0]
      this.table[1][0] = result.reels[0][0]
      this.table[2][0] = result.reels[0][1]
      this.table[3][0] = result.reels[0][2]
      this.table[0][1] = result.nextReel[1][0]
      this.table[1][1] = result.reels[1][0]
      this.table[2][1] = result.reels[1][1]
      this.table[3][1] = result.reels[1][2]
      this.table[0][2] = result.nextReel[2][0]
      this.table[1][2] = result.reels[2][0]
      this.table[2][2] = result.reels[2][1]
      this.table[3][2] = result.reels[2][2]
      this.table[0][3] = result.nextReel[3][0]
      this.table[1][3] = result.reels[3][0]
      this.table[2][3] = result.reels[3][1]
      this.table[3][3] = result.reels[3][2]
      this.table[0][4] = result.nextReel[4][0]
      this.table[1][4] = result.reels[4][0]
      this.table[2][4] = result.reels[4][1]
      this.table[3][4] = result.reels[4][2]
      this.symbolsDetail = result.winnings
      this.isEndRound = result.isEndRound;
      this.winlose = result.win;
      this.bet = result.bet;
      this.balance = result.balance;
      this.winnings = result.winnings;

      if (result.isCoin) this.currency = 'AMS';
    },
    async addCount() {
      this.data.count += 1;
      if (this.data.count > this.data.detail.summary.length - 1) {
        this.pages += 1;
        this.$emit('fetchResult', this.page + 1)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }

    },
    async delCount() {
      this.data.count -= 1;
      if (this.page > 0) {
        this.pages -= 1;
        this.$emit('fetchResult', this.page - 1, true)
      } else {
        await this.mapSymbol(this.data.detail.summary[this.data.count]);
      }
    },
  }
}
</script>

<style scoped>
body {
  font-family: "Prompt", sans-serif;
  background-color: #292933
    /* margin: 0; */
}

.wheel-wrapper {
  position: absolute;
  width: 570px;
  height: 100%;
  top: 7px;
}

.fg-image {
  width: 570px;
}

.multiplier-wrapper {
  top: -95px;
  z-index: 6;
  height: 134px;
  overflow: hidden;
}

.multiplier-image {
  width: 90%;
  transform: scale(0.9);
  margin-left: 21px;
}

.icon-detail-moemoecute {
  width: 85px;
  height: 85px;
  padding: 4px;
}

.icon-bonus-moemoecute {
  width: 100px;
  height: 100px;
  padding: 10px;
}

.arrow {
  color: #cac095;
  text-align: center;
}

.arrow-side-moemoecute {
  cursor: pointer;
  color: #ffff;
  text-align: center;
  font-size: 90px;
}

.arrow-side-monster:hover {
  color: #06112d;
  text-align: center;
  /* font-size: 90px; */
}

.bet-box-moemoecute {
  background: #0c161f;
  border-radius: 10px;
  min-height: 200px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bonus-box-moemoecute {
  background: #0c161f;
  border-radius: 10px;
  min-height: 150px;
  max-height: 300px;
  overflow-y: scroll;
  min-width: 100px;
  max-width: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.bet-wrapper-moemoecute .item {
  color: #fff;
  background: #06112d;
  line-height: 1;
  border-radius: 10px;
  border: 1.5px solid #cac095;
}

.bet-box-moemoecute .bet-wrapper-moemoecute:not(:first-child) .item {
  margin-top: 10px;
}

.bet-wrapper-moemoecute,
.result-wrapper {
  font-size: 35px;
}

.header-moemoecute {
  background: #FFC7D0;
  padding: 10px 0;
  flex-wrap: wrap;
}

.header-moemoecute>div {
  flex-grow: 1;
  font-size: 20px;
  line-height: 1.1;
}

.heading-moemoecute {
  color: #000000;
  text-align: center;
}

.content-result-moemoecute {
  background: #AA3040;
  height: 150vh;
  width: 100%;
  background-size: cover;
  background-attachment: scroll;
  background-repeat: no-repeat;
}

.title>.heading-moemoecute {
  font-size: 40px;
  font-weight: bold;
  margin-bottom: 0;
}

.title>.sub {
  font-size: 30px;
  line-height: 1;
}

.text-games-moemoecute {
  color: #ffffff;
  font-size: 25px;
  text-align: center;
}

.text-subhead-moemoecute {
  font-size: px;
  color: #5A5A5A;
  text-align: center;
}

.text-subgame-moemoecute {
  font-size: 20px;
  color: #FFD500;
  text-align: center;
}

.text-date {
  font-size: px;
  color: #FFF5BF;
  text-align: center;
}

.text-detail {
  font-size: 20px;
  color: #c7b873;
  text-align: center;
}

.icon-symbol-moemoecute {
  width: 100%;
  /* padding: 5%; */
}

.bet-box-moemoecute {
  min-width: 600px;
  max-width: auto;
}

.table-moemoecute {
  z-index: 5;
  background-size: 570px 440px;
  /* set Bg Table HERE */
  width: 570px;
  height: 440px;
  border-radius: 5px;
  font-size: 30px;
  text-align: center;
}

@media screen and (max-width: 1030px) {
  .table-moemoecute {
    background-size: 500px 400px;
    width: 500px;
    height: 380px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }


  .fg-image {
    width: 500px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .wrapper {
    flex-direction: column;
  }

  .wrapper>div:first-child {
    order: 2;
  }

  .wrapper>div:last-child {
    order: 1;
  }

  .arrow-side-monster {
    font-size: 60px;
  }

  .bet-box-moemoecute {
    min-width: 580px;
    max-width: auto;
    height: 280px;
  }

  .bet-wrapper-moemoecute,
  .result-wrapper {
    font-size: 35px;
  }
}

@media screen and (min-width: 1060px) {

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .fg-image {
    width: 570px;
    margin-left: -34px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(1);
    margin-left: 21px;
  }

  .d-md-spec-flex {
    display: flex;
  }

  .result-wrapper .symbol {
    width: 140px;
  }

  .bet-wrapper-moemoecute,
  .result-wrapper {
    font-size: 33px;
  }

}

.line {
  background-color: #c7b873;
  height: 2px;
  width: 100%;
}

.red {
  color: #ff0000;
}

.green {
  color: #10b24b;
}

@media screen and (max-width: 770px) {
  .heading-moemoecute {
    font-size: 18px;
  }

  .table-moemoecute {
    background-size: 470px 400px;
    width: 470px;
    height: 300;
    margin-bottom: 1%;
  }

  .fg-image {
    width: 470px;
  }

  .wheel-wrapper {
    position: absolute;
    width: 470px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.9);
    margin-left: 21px;
  }

  .front-table-moemoecute {
    background: url('~@/assets/resultGame/moemoe/slot_slotmachine.png') no-repeat;
    background-size: 470px 400px;
    width: 470px;
    height: 300;
    margin-bottom: 1%;
    /* padding-bottom: 35px; */
  }

  .text-subhead-moemoecute {
    font-size: 18px;
  }

  .arrow-side-monster {
    font-size: 30px;
  }

  .bet-box-moemoecute {
    min-width: 430px;
    max-width: auto;
  }

  .text-date {
    font-size: 20px;
    color: #c7b873;
    text-align: center;
  }
}

@media screen and (max-width: 480px) {

  .wheel-wrapper {
    position: absolute;
    width: 500px;
    height: 100%;
    top: 7px;
  }

  .multiplier-wrapper {
    top: -95px;
    z-index: 6;
    height: 134px;
    overflow: hidden;
  }


  .fg-image {
    width: 230px;
    height: 189px;
    margin-left: 135px;
    margin-top: -9px;
  }

  .multiplier-image {
    width: 90%;
    transform: scale(0.4);
    margin-left: 21px;
  }

  .header-moemoecute>div {
    flex-grow: 0;
    width: 25%;
  }

  .heading-moemoecute {
    font-size: 12px;
  }

  .table-moemoecute {
    background-size: 250px 180px;
    width: 250px;
    height: 180px;
    /* padding-top: 2.0rem; */
  }

  .text-subhead-moemoecute {
    font-size: 14px;
  }

  .bet-box-moemoecute {
    min-width: 230px;
    max-width: auto;
    height: 200px;
  }

  .bonus-box-moemoecute {
    min-width: 230px;
    max-width: auto;
    height: 150px;
  }

  .bet-wrapper-moemoecute,
  .result-wrapper {
    font-size: 20px;
  }

  .icon-detail-moemoecute {
    width: 45px;
    height: 50px;
  }

  .icon-bonus-moemoecute {
    width: 60px;
    height: 60px;
  }
}

@media screen and (max-width: 550px) {
  .fg-image {
    width: 390px;
  }

  .wheel-wrapper {
    width: 396px;
  }

  .container {
    padding-bottom: 67px;
  }
}
</style>